import { Seo } from "../components/onix/Seo";
import { SectionEyebrow } from "../components/onix/SectionEyebrow";
import { ContactForm } from "../components/onix/ContactForm";
import { Reveal } from "../components/onix/Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function Contacto() {
  const { t } = useLang();
  const tk = t.contact;
  return (
    <main className="pt-[76px]">
      <Seo title={tk.seoTitle} description={tk.seoDesc} path="/contacto" />

      <section className="onix-shell py-20 md:py-32">
        <Reveal>
          <SectionEyebrow index="01" label={tk.label} />
        </Reveal>
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold font-serif leading-[1.05] text-onix-white mb-8">
                {tk.h1}
              </h1>
              <p className="text-base md:text-lg leading-relaxed text-onix-silver max-w-md mb-12">
                {tk.intro}
              </p>
              <div className="space-y-0 border-b border-onix-line">
                {tk.steps.map((s) => (
                  <div key={s.num} className="flex items-baseline gap-6 border-t border-onix-line py-5">
                    <span className="tech-label shrink-0">{s.num}</span>
                    <p className="text-sm leading-relaxed text-onix-silver">{s.text}</p>
                  </div>
                ))}
              </div>
              <p className="tech-label mt-12">INTELLIGENCE DRIVEN · MISSION FOCUSED</p>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <ContactForm />
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
